export default "__VITE_ASSET__BFmlm3PT__"